const categoryTabs = {
    tabs: document.querySelectorAll('.jsTab'),
    tabsName: document.querySelectorAll('.jsTabText'),
    wrap: document.getElementById('tabWrap'),
    line: document.getElementById('tabLine'),
    catSlider: document.getElementById('catSlider'),   

    init() {
       this.setTabs();

    },
    setTabs() {
        this.tabs.forEach((item, index)=>{    
            item.firstElementChild.innerText = this.tabsName[index].dataset.name;
            item.addEventListener('click',()=>{
                this.tabs.forEach(item => item.classList.remove('activeClass'));
                item.classList.add('activeClass'); 
                this.catSlider.style.transform = `translateY(${-25 * index}%)`;
            });
        });
    }

}

export default categoryTabs;